import { ReactNode, useState } from 'react';
import { TabListContext } from './tab-list-context';

interface TabListProviderProps {
  children: ReactNode;
}

export function TabListProvider({ children }: TabListProviderProps) {
  const [tabs, setTabs] = useState<Record<string, number>>({});

  return <TabListContext.Provider value={[tabs, setTabs]}>{children}</TabListContext.Provider>;
}
